"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.simulateSpectrum = exports.getSpinSystems = exports.defaultSimulationOptions = void 0;
const nmr_processing_1 = require("nmr-processing");
exports.defaultSimulationOptions = {
    data: [],
    options: {
        frequency: 200,
        from: -1,
        to: 12,
        nbPoints: 2 ** 16,
        lineWidth: 1,
    },
};
function getSpinSystems() {
    const spinSystem = [];
    let temp = 'A';
    for (let i = 66; i <= 72; i++) {
        temp += String.fromCodePoint(i);
        spinSystem.push(temp);
    }
    return spinSystem;
}
exports.getSpinSystems = getSpinSystems;
function simulateSpectrum(spinSystem, options) {
    const spinsLength = spinSystem.length;
    const chemicalShifts = new Array(spinsLength);
    const multiplicity = new Array(spinsLength);
    const { data: spinsData, options: simulateOptions } = options;
    for (let i = 0; i < spinsLength; i++) {
        chemicalShifts[i] = spinsData[i][0];
        multiplicity[i] = 2;
    }
    const chemicalShiftsLength = chemicalShifts.length;
    const couplingConstants = new Array(chemicalShiftsLength);
    for (let i = 0; i < chemicalShiftsLength; i++) {
        couplingConstants[i] = new Array(chemicalShiftsLength);
        for (let j = 0; j < chemicalShiftsLength; j++) {
            couplingConstants[i][j] = 0;
        }
    }
    for (let i = 0; i < spinsData.length; i++) {
        for (let j = 1; j < chemicalShiftsLength; j++) {
            const couplingVal = spinsData[i][j];
            const jIndex = j - 1;
            if (couplingVal !== null) {
                couplingConstants[i][jIndex] = couplingVal;
                couplingConstants[jIndex][i] = couplingVal;
            }
        }
    }
    return (0, nmr_processing_1.simulate1D)({
        chemicalShifts,
        couplingConstants,
        levels: multiplicity,
    }, simulateOptions);
}
exports.simulateSpectrum = simulateSpectrum;
